<template>
  <div class="split-line" />
</template>

<script>
export default {}
</script>

<style scoped>
.split-line {
  height: 1px;
  background: #1f263b;
  margin: 8px 0;
}
</style>
